import { useRef } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';

// NOTE: Use Charlie font for this modal
import { cssReset } from '@atlassiansox/wpl-utils';

import { ImageSuccessPaperPlane } from '../assets/image-success-paper-plane';
import {
  modalStyles,
  ctaButtonStyles,
  closeModalButtonStyles,
  descriptionStyles,
  imageStyles
} from './success-modal.styles';
import { CloseModalButton } from './close-modal-button';
import { useInteractiveBoardStore, useMessages } from '../state';
import { TRACKING_EVENT_NAMES } from '../constants/analytics';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export const SuccessModal = () => {
  const [
    { isDemoCompleteModalOpen },
    { toggleCompleteDemoModalOpen, completeDemo }
  ] = useInteractiveBoardStore();
  const { createAnalyticsEvent } = useAnalyticsEvents();
  const [messages] = useMessages();

  const ctaRef = useRef<HTMLAnchorElement>(null);

  function onClose() {
    createAnalyticsEvent({
      eventName: TRACKING_EVENT_NAMES.jswInteractiveBoardSuccessModalGetStarted,
      action: 'clicked',
      actionSubject: 'button',
      eventType: 'UI',
      isDemoComplete: true
    }).fire();
    void toggleCompleteDemoModalOpen();

    // TODO: Move logic to onCloseComplete once bug is fixed
    // https://product-fabric.atlassian.net/browse/DSP-3926
    setTimeout(() => {
      createAnalyticsEvent({
        eventName: TRACKING_EVENT_NAMES.jswInteractiveBoardSuccessModalClosed,
        action: 'clicked',
        actionSubject: 'button',
        eventType: 'UI',
        isDemoComplete: true
      }).fire();
      void completeDemo();
    }, 500);
  }

  return (
    <ModalTransition>
      {isDemoCompleteModalOpen && (
        <Modal
          label={messages.successModalHeading}
          onClose={onClose}
          width={440}
          // Disabling because this follows atlaskit pattern https://atlassian.design/components/modal-dialog/examples#focus-management
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={ctaRef}
        >
          <div css={[cssReset, modalStyles]}>
            <CloseModalButton
              onCloseClick={onClose}
              styleOverrides={closeModalButtonStyles}
            />
            <div css={imageStyles}>
              <ImageSuccessPaperPlane />
            </div>
            <Heading as="h2" level="h600">
              {messages.successModalHeading}
            </Heading>
            <p css={descriptionStyles}>{messages.successModalDescription}</p>
            <Button
              css={ctaButtonStyles}
              appearance="warning"
              href="/software/jira/free"
              onClick={onClose}
              ref={ctaRef}
            >
              {messages.successModalCtaButton}
            </Button>
          </div>
        </Modal>
      )}
    </ModalTransition>
  );
};
